import { useState } from 'react';
import moment from 'moment-timezone';
import useApi from '../../../../Hooks/useApi';

export default function useReservations() {
  const [reservations, setReservations] = useState([]);
  const api = useApi();

  const fetchReservationsForMonth = async (monthMoment = null) => {
    try {
      const baseDate = monthMoment || moment().tz('Europe/Amsterdam');
      const beginDate = baseDate.clone().startOf('month').format('YYYY-MM-DD');
      const endDate = baseDate.clone().endOf('month').format('YYYY-MM-DD');
      const restaurantId = window.restaurantId;
      const endpoint = `${window.baseDomain}api/slots/${restaurantId}/${beginDate}/${endDate}`;

      const data = await api.get(endpoint, { noCache: false });
      setReservations(data || []);
    } catch (error) {
      console.error('Error fetching reservations:', error);
    }
  };

  return { reservations, fetchReservationsForMonth };
}


